export default __webpack_public_path__ + "static/media/7minfitness_6.552c6d10.jpg";